import * as React from 'react';
import { useAccountPositionGesEstimDExRatePerformance } from '../../hooks';
import { ActorApiNumberDisplay } from '../../../../../../components/display/number/component';

export const AccountsPositionsGesEstimDExratePerformance = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionGesEstimDExRatePerformance();
  return (
    <ActorApiNumberDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      format={{
        style: 'percent',
      }}
      divider={1}
    />
  );
};
